import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M2 14h3v-2a2 2 0 1 1 4 0v2v-1.5a2.5 2.5 0 1 1 5 0v1.5v-1.5a2.5 2.5 0 1 1 5 0v1.5h3","key":"svg-0"}]]

/**
 * IconCircuitInductor
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItY2lyY3VpdC1pbmR1Y3RvciIKPgogIDxwYXRoIHN0cm9rZT0ibm9uZSIgZD0iTTAgMGgyNHYyNEgweiIgZmlsbD0ibm9uZSIgLz4KICA8cGF0aCBkPSJNMiAxNGgzdi0yYTIgMiAwIDEgMSA0IDB2MnYtMS41YTIuNSAyLjUgMCAxIDEgNSAwdjEuNXYtMS41YTIuNSAyLjUgMCAxIDEgNSAwdjEuNWgzIiAvPgo8L3N2Zz4=) - https://tabler.io/icons/icon/circuit-inductor
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconCircuitInductor = createReactComponent('outline', 'circuit-inductor', 'CircuitInductor', __iconNode);

export default IconCircuitInductor;